import { graphql } from '@xolv-mybrightlink/common';
import { gql } from '@apollo/client';
import { CsatSurveyResponse } from '../models/CsatSurveyResponse';
import { CsatSurvey } from '../models/CsatSurvey';
import { parseISO } from 'date-fns';

export const fetchCsatSurveys = async (): Promise<CsatSurvey[]> => {
  const { data } = await graphql.query<{ csatSurveys: CsatSurveyResponse[] }>({
    query: fetchCsatSurveysQuery,
    fetchPolicy: 'no-cache',
  });
  return data.csatSurveys.map((surveyResponse: CsatSurveyResponse) =>
    csatSurveyFromJson(surveyResponse),
  );
};

const csatSurveyFromJson = (json: CsatSurveyResponse): CsatSurvey => {
  return {
    type: 'CSAT',
    surveyGuid: json.surveyGuid,
    patientFirstName: json.patient.firstName,
    patientLastName: json.patient.lastName,
    patientSfId: json.patientSfId,
    surveyLink: json.surveyLink,
    expirationDate: parseISO(json.expirationDate),
  };
};

const fetchCsatSurveysQuery = gql`
  query csatSurveys {
    csatSurveys {
      surveyGuid
      patientSfId
      surveyLink
      expirationDate
      patient {
        firstName
        lastName
      }
    }
  }
`;
